import { WorkflowRunSimulateContext } from 'dashboard/models/workflow-run-simulated';
import { FieldSchema } from 'lib/fields';

const FIELD_KEY_TO_SIMULATED_VALUE: { [key: string]: string } = {
  birthdate: '1977-07-17',
  name_first: 'Alexander',
  first_name: 'Alexander',
  name_last: 'Sample',
  last_name: 'Sample',
  name_middle: 'J',
  middle_name: 'J',
  identification_number: 'I1234562',
  social_security_number: '123-45-6789',
  id_class: 'dl',
  identification_class: 'dl',
  selected_id_class: 'dl',
  phone_number: '123-456-7890',
  email_address: 'alexanderjsample@example.com',
  email: 'alexanderjsample@example.com',
  address_street_1: '600 California St',
  address_city: 'San Fransisco',
  address_subdivision: 'CA',
  address_postal_code: '94109',
  issuing_authority: 'CA',
  issuing_subdivision: 'CA',
  country_code: 'US',
  selected_country_code: 'US',
  business_name: 'Acme Inc',
  business_address_city: 'San Fransisco',
  business_address_subdivision: 'CA',
  business_ein: '12-3456789',
};

export const generateSimulatedTriggerFieldOverrides = (
  fieldSchemas: FieldSchema[],
  simulateContext: WorkflowRunSimulateContext,
) => {
  if (fieldSchemas.length === 0) {
    return simulateContext.trigger?.overrides;
  } else {
    return fieldSchemas.reduce<Record<string, string>>((acc, schema) => {
      // filter out override if that field is inactive
      if (schema.config['deactivated-at'] != null) {
        return acc;
      }

      const value =
        simulateContext.trigger?.overrides?.[`fields.${schema.key}`] ||
        FIELD_KEY_TO_SIMULATED_VALUE[schema.key];
      if (value) {
        return {
          ...acc,
          [`fields.${schema.key}`]: value,
        };
      }
      return acc;
    }, {});
  }
};

export const sanitizeFields = (overrides: Record<string, string | number | boolean | null>) => {
  return Object.entries(overrides).reduce<Record<string, string>>(
    (acc, [key, value]) => ({
      ...acc,
      ...(value ? { [key]: value.toString() } : {}),
    }),
    {},
  );
};
